






















import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { CheckErrorData } from '@/models/student/check-student-differences-result';

@Component({ name: 'GStudentImportErrorModal' })
export default class GStudentImportErrorModal extends Vue {
  show: boolean = false;

  @Prop() value: boolean;
  @Prop({ default: (): CheckErrorData[] => [] }) errors: CheckErrorData[];

  @Watch('value')
  onValueChange(v: boolean) {
    this.show = v;
  }

  @Watch('show')
  onShowChange(v: boolean) {
    this.$emit('input', v);
  }

  get columns(): object[] {
    return [
      {
        title: '行番号',
        key: 'rowNum',
        width: 90,
        align: 'center',
        render: (h: any, { row }: any): any => h('span', { style: { display: 'block', textAlign: 'right' } }, String(row.rowNum)),
      },
      {
        title: 'ログインID',
        key: 'studentNumber',
        width: 140,
        align: 'center',
        render: (h: any, { row }: any): any => h('span', { style: { display: 'block', textAlign: 'left' } }, row.studentNumber),
      },
      {
        title: 'エラー種別',
        key: 'errorMessageMain',
        width: 220,
        align: 'center',
        render: (h: any, { row }: any): any =>
          h('span', { style: { display: 'block', textAlign: 'left', color: '#c0392b', fontWeight: 'bold', whiteSpace: 'pre-line' } }, row.errorMessageMain),
      },
      {
        title: '詳細',
        key: 'errorMessageSub',
        align: 'center',
        render: (h: any, { row }: any): any =>
          h('span', { style: { display: 'block', textAlign: 'left', whiteSpace: 'pre-line' } }, row.errorMessageSub),
      },
    ];
  }

  handleOK() {
    this.show = false;
    this.$emit('ok');
  }
}
